import { Flex } from "atoms/grid";
import { P } from "atoms/legacy-typography";
import LegacyButton from "atoms/LegacyButton";
import { colors, zIndex } from "lib/theme";
import { withAppSwitch } from "lib/withAppSwitch";
import { useRouter } from "next/router";
import { parseCookies, setCookie } from "nookies";
import { useEffect, useState } from "react";
import styled from "styled-components";

const Banner = styled(Flex).attrs({
  flexDirection: ["column", "row"],
  alignItems: [, "center"],
  justifyContent: [, "center"],
  p: ["12px 100px 12px 20px", , , "12px 20px"],
})`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: ${zIndex.tooltip};
  background-color: ${colors.gray[800]};
  transform: translateY(${(p) => (p.visible ? 0 : 100)}%);
  transition: 0.5s ease-in-out transform;
  color: ${colors.white};
`;

const getCookieAcceptance = () => {
  return !!parseCookies({}).cookiesAccepted;
};

const setCookieAcceptance = () => {
  // "Consent renewal must be done every 12 months when the user revisits the website."
  // https://www.cookielawinfo.com/requirements-of-a-gdpr-compliant-cookie-banner/
  setCookie({}, "cookiesAccepted", "true", {
    maxAge: 365 * 24 * 60 * 60,
    path: "/",
  });
};

const useIsPublicPage = () => {
  const router = useRouter();
  return !(
    router.pathname.startsWith("/account") || router.pathname === "/create"
  );
};

// Assume accepted on server render
const defaultAccepted = true;

const CookieBanner = () => {
  const isPublicPage = useIsPublicPage();
  const [accepted, setAccepted] = useState(defaultAccepted);

  useEffect(() => {
    setAccepted(getCookieAcceptance());
  }, []);

  const visible = isPublicPage && !accepted;

  return (
    <Banner visible={visible}>
      <P color={colors.white}>
        <b>Do you like cookies?</b> &#x1F36A; We use cookies to ensure you get
        the best experience on our website.
      </P>

      <LegacyButton
        width={["100%", "auto"]}
        small
        p="10px"
        mt={[16, 0]}
        ml={[, 20]}
        onClick={() => {
          setCookieAcceptance();
          setAccepted(true);
        }}
      >
        I agree
      </LegacyButton>
    </Banner>
  );
};

export default withAppSwitch({ Web: CookieBanner });
